const answerSelector = [
  '[data-questionnaire-answer]:not([disabled])',
  'textarea:not([disabled])',
  'input:not([type="hidden"]):not([disabled])',
  'select:not([disabled])'
].join(', ');

const fallbackSelector = [
  '[data-questionnaire-primary-action]:not([disabled])',
  '[data-questionnaire-skip]:not([disabled])',
  '[data-questionnaire-previous]:not([disabled])'
].join(', ');

const canReceiveFocus = (element) => {
  if (
    !element ||
    !element.isConnected ||
    element.hasAttribute('disabled') ||
    element.closest('[inert], [aria-hidden="true"]') ||
    element.getClientRects().length === 0
  ) {
    return false;
  }

  const style = window.getComputedStyle(element);

  return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
};

const focusWithoutJump = (element) => {
  if (!canReceiveFocus(element)) return false;

  try {
    element.focus({ preventScroll: true });
  } catch (_) {
    element.focus();
  }

  return document.activeElement === element;
};

export const QuestionnaireNavigation = {
  mounted() {
    this.previousActiveElement =
      document.activeElement instanceof HTMLElement && document.activeElement !== document.body
        ? document.activeElement
        : null;
    this.lastNodeKey = this.el.dataset.questionnaireNodeKey || '';
    this.lastErrorMessage = this.errorMessage();
    this.focusFrame = requestAnimationFrame(() => this.focusCurrentTarget());
  },

  updated() {
    const nodeKey = this.el.dataset.questionnaireNodeKey || '';
    const errorMessage = this.errorMessage();

    if (errorMessage && errorMessage !== this.lastErrorMessage) {
      this.focusError();
    } else if (nodeKey && nodeKey !== this.lastNodeKey) {
      this.focusCurrentTarget();
    }

    this.lastNodeKey = nodeKey;
    this.lastErrorMessage = errorMessage;
  },

  destroyed() {
    if (this.focusFrame) cancelAnimationFrame(this.focusFrame);

    const fallback = document.getElementById('microsite-root');

    if (fallback && !fallback.hasAttribute('tabindex')) {
      fallback.setAttribute('tabindex', '-1');
    }

    requestAnimationFrame(() => {
      if (!focusWithoutJump(this.previousActiveElement)) {
        focusWithoutJump(fallback);
      }
    });
  },

  errorMessage() {
    return this.el.querySelector('#microsite-questionnaire-error')?.textContent?.trim() || '';
  },

  focusError() {
    const error = this.el.querySelector('#microsite-questionnaire-error');

    if (focusWithoutJump(error)) {
      error.scrollIntoView({ block: 'nearest' });
    }
  },

  focusCurrentTarget() {
    const error = this.el.querySelector('#microsite-questionnaire-error');

    if (error && this.errorMessage()) {
      this.focusError();
      return;
    }

    const target = this.el.querySelector(answerSelector) || this.el.querySelector(fallbackSelector);

    if (focusWithoutJump(target)) {
      const node = this.el.querySelector('[data-test="microsite-questionnaire-node"]');
      if (node) node.scrollTop = 0;
    }
  }
};
